import { useSelector } from "react-redux";
import { routeConstant } from "shared/routes/routeConstant";
import ProjectsList from "shared/components/dashboardCommon/projectsList";

const DesignerMyProjects = () => {
  const auth = useSelector((state: any) => state.root.auth);

  return (
    <ProjectsList
      userType="designer"
      onlyMyProjects={true}
      pageTitle={`${auth?.user?.display_name || "Sarah"}'s Projects`}
      pageDescription="Your creative workspace — all current builds in one place."
      showSearchFilter={true}
      EnableApiIntegration={true}
      noContentMessage="You don't have any projects at the moment. Start creating to see them here."
      detailRoutePath={routeConstant.designer.projectDetail.path}
      showArchiveButton={true}
    />
  );
};

export default DesignerMyProjects;
